// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__ziLCo","header":"MergedInvoice_header__P04Ut"};